export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    RECORD_USER_PAY_ALL: function RECORD_USER_PAY_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/record-user-pay/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    RECORD_USER_PAY_CREATE: function RECORD_USER_PAY_CREATE(data) {
      return request({
        url: '/api/record-user-pay/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    RECORD_USER_PAY_DETAIL: function RECORD_USER_PAY_DETAIL(id) {
      return request({
        url: '/api/record-user-pay/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    RECORD_USER_PAY_UPDATE: function RECORD_USER_PAY_UPDATE(data) {
      return request({
        url: '/api/record-user-pay/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    RECORD_USER_PAY_DELETE: function RECORD_USER_PAY_DELETE(id) {
      return request({
        url: '/api/record-user-pay/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});